<template>
  <v-app class="layout-wrapper">
    <loading :active.sync="busy"/>

    <!-- Contents -->
    <div class="content">
      <!-- Header -->
      <header class="header" :key="mp_header_key"
        :style="{width: mp_header_width}">
        <!-- Account -->
        <div class="header-start">
          <router-link tag="div"
            class="bt-menu"
            :to="{name:'lab'}">
            <span  class="link-element">{{ $t('header.lab') }}</span>
            <span>&nbsp;|&nbsp;</span>
          </router-link>
          <!-- <router-link tag="div"
            class="bt-menu"
            :to="{name:'gallery'}">
            <span  class="link-element">{{ $t('header.gallery') }}</span>
            <span>&nbsp;|&nbsp;</span>
          </router-link> -->
        </div>

        <div class="header-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div class="bt-title" v-on="on">
                <v-clamp autoresize :max-lines="1">{{ mp_info.title }}</v-clamp>
              </div>
            </template>
            <span>{{ mp_info.title }}</span>
          </v-tooltip>
          <div class="header-tools">
            <!-- Fork -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn x-small icon v-on="on"
                  @click.stop="forkPiece()">
                  <v-icon small v-if="!!mp_info.my_fork"
                    color="primary">mdi-source-fork</v-icon>
                  <v-icon small v-else>mdi-source-fork</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('fork_mp.fork') }}</span>
            </v-tooltip>

            <div class="icon-number">{{ mp_info.num_forks }}</div>

            <!-- Like -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn x-small icon v-on="on"
                  @click="likePiece(mp_info.my_like)">
                  <v-icon small v-if="!!mp_info.my_like" 
                    color="secondary">mdi-heart</v-icon>
                  <v-icon small v-else>mdi-heart-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('fork_mp.like') }}</span>
            </v-tooltip>

            <div class="icon-number">{{ mp_info.like }}</div>
          </div>
        </div>
      </header>

      <!-- Body -->
      <div class="mp-body">

        <!-- Tree tools -->
        <section class="tree-tools"
          v-show="!!mp_info.num_docs">

          <div>
            <!-- Reload -->
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <div class="tree-tool" v-on="on"
                  @click="forceTreeToRender()">
                  <v-icon small>mdi-reload</v-icon>
                </div>
              </template>
              <span>{{ $t('mp.reload') }}</span>
            </v-tooltip>

            <!-- TODO: Zoom -->
            <!-- <div class="tree-tools-twin">
              <v-icon small>mdi-plus</v-icon>
              <v-icon small>mdi-minus</v-icon>
            </div> -->
          </div>

          <!-- Legend -->
          <div class="tree-legend">
            <div class="legend-row">
              <div class="legend-square">
                <div class="square"></div>
              </div>
              <div>{{ $t('mp.masterpiece')}}</div>
            </div>
            <div class="legend-row">
              <div class="legend-dot">
                <div class="dot" :style="{'border':'1px solid black'}"></div>
              </div>
              <div>{{ $t('mp.in_masterpiece')}}</div>
            </div>
            <div class="legend-row">
              <div class="legend-dot">
                <div class="dot"></div>
              </div>
              <div>{{ $t('mp.not_in_masterpiece')}}</div>
            </div>
            <hr class="horizontal-line" v-if="!!legend_doc_types.length"/>
            <div class="legend-row" v-if="!!legend_doc_types.length"
              v-for="(t, i) in legend_doc_types" :key="i">
              <div class="legend-dot">
                <div class="dot" :style="{'background-color': doc_types[t].color}"></div>
              </div>
              <div>{{ $t('doc_types.' + doc_types[t].keyname) }}</div>
            </div>
          </div>
        </section>

        <!-- Tree -->
        <section class="tree">
          <app-tree
            :documents="sorted_documents"
            :idocuments="index_documents"
            :ldocuments="legend_documents"
            :sortby="sort_by"
            :treetype="tree_type"
            :treedepth="tree_depth"
            drawer=true
            ref="tree"/>
        </section>
      </div>

      <!-- Drawer -->
      <div class="drawer-wrap">
        <div class="drawer"
          :style="{ width: project_drawer_width + 'px'}">
          <app-drawer
            :sortby.sync="sort_by"
            :documents="sorted_documents"
            :legend.sync="legend_documents"
            :index.sync="index_documents"/>
        </div>
      </div>

      <!-- Modals -->
      <modal-fork-masterpiece
        :dialog.sync="dialog_fork">
      </modal-fork-masterpiece>

      <modal-expired></modal-expired>

    </div>
  </v-app>
</template>

<script>
import VClamp from 'vue-clamp'
import { mapGetters } from 'vuex'

import AppDrawer from './Drawer.vue'

import { sortDocuments, returnDocDetail } from '../../../custom/function'
import { doc_types } from '../../../custom/model'

export default {
  metaInfo() {
    return {
      title: "Masterpiece"
    }
  },

  components: {
    AppDrawer,
    VClamp,
  },

  data() {
    return {
      busy: false,
      doc_types: doc_types,

      project_drawer_width: 450,

      sort_by: 4,
      sorted_documents: [],
      legend_documents: [],
      index_documents: [],

      tree_type: 1,
      tree_depth: 2,

      dialog_fork: false,

      mp_header_key: 0,
      mp_header_width: 'calc(100% - 450px)'
    }
  },

  computed: {
    ...mapGetters({
      mp_info: 'gallery/masterpiece',
      raw_documents: 'gallery/documents',
      expired: 'auth/is_expired',
      mp_id: 'welcome/mp_id',
    }),

    // mp_id() {
    //   return parseInt(this.$route.params.id)
    // },

    raw_doc_keys() {
      return this.raw_documents.map(v => v.key)
    },

    legend_doc_types() {
      return Array.from(new Set(this.legend_documents.map(v=>v.doc_type)))
    },
  },

  watch: {
    mp_id: {
      async handler() {
        await this.getMasterpiece()
      },
      immediate: true,
    },

    raw_doc_keys: {
      handler(val) {
        let vm = this
        let docs = []
        if (!!val.length) {
          this.raw_documents.forEach((doc, i) => {
            docs.push(vm.returnDocDetail(doc, doc.doc_type))
            docs[i].my_like = doc.my_like
          })
        }
        this.updateDocuments(docs, this.sort_by)
      }
    },

    sort_by(val) {
      this.updateDocuments(this.sorted_documents, val)
    },
  },

  methods: {
    returnDocDetail,
    sortDocuments,

    async getMasterpiece() {
      this.busy = true
      let vm = this
      // try {
      //   await this.$store.dispatch('gallery/getMasterpieces')
      // } catch(e) {
      //   this.$store.commit('error/setDialog', true)
      //   this.$store.commit('error/setErrorCode', e.response.status)
      // } finally {
      //   let mps = this.$store.getters['gallery/masterpieces']
      //   let mp_ids = mps.map(v => v.mp_id)
      //   if (!mps.length || !mp_ids.includes(vm.mp_id)) {
      //     this.$router.replace({ name: 'gallery' })
      //   }
      //   else {
          try {
            await this.$store.dispatch('gallery/getMasterpiece', this.mp_id)
          } catch(e) {
            this.$store.commit('error/setDialog', true)
            this.$store.commit('error/setErrorCode', e.response.status)
          } 
        // }
        this.busy = false
      // }
    },

    updateDocuments(docs, sort_by) {
      // console.log('sortDocuments', docs, sort_by)
      let new_docs = []
      if (!!docs.length) {
        new_docs = this.sortDocuments(docs, parseInt(sort_by))
      }
      this.sorted_documents = new_docs
    },

    forceTreeToRender() {
      this.updateDocuments(this.sorted_documents, this.sort_by)
      this.$refs.tree.initiateZoom()
    },

    async likePiece(like) {
      let action = like == 0 ? 'vote' : 'cancel'
      this.$analytics.logEvent('click', { name: 'piece_btn_like' })
      await this.$store.dispatch('gallery/voteMasterpiece', {
        mp_id: this.mp_id,
        action,
      })
    },

    forkPiece() {
      if (this.expired) {
        this.$store.commit('modal/showExpired')
      } else {
        this.dialog_fork = true
      }
    },
  }
}
</script>

<style scoped>

  .layout-wrapper {
    min-width: 1000px;
  }

  /* Content */

  .content {
    display: flex;
    flex-direction: column;
  }

  /* Header */

  .header {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    height: 60px;
    min-width: 300px;
    display: grid;
    grid-template-columns: 80px auto;
    padding: 0 20px;
  }

  .header > div {
    display: flex;
    align-items: center;
    margin-right: 8px;
  }

  .header-start, .content-account {
    display: flex;
    align-items: center;
  }

  .header-start > div {
    margin-right: 8px;
  }

  .header-center > div {
    margin-right: 8px;
  }

  .header-tools {
    width: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header-tools > div {
    margin: 0 4px;
  }

  .bt-menu {
    font-family: "Montserrat", sans-serif;
  }

  .bt-title {
    font-family: "Montserrat", sans-serif;
    padding: 5px;
    font-size: 24px;
    font-weight: 700;
  }

  .icon-number {
    font-family: 'Montserrat', sans-serif;
  }

  /* Body */
  .mp-body {
    height: 100vh;
  }

  /* Tree tools */

  .tree-tools {
    position: absolute;
    z-index: 100;
    top: 64px;
    height: calc(100vh - 64px);
    left: 0;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    visibility: hidden;
  }

  .tree-tool {
    position: relative;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 16px;
    background-color: white;
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    visibility: visible;
  }

  .tree-tools-twin {
    position: relative;
    cursor: pointer;
    width: 30px;
    height: 60px;
    display: grid;
    grid-template-rows: 30px 30px;
    margin: 10px 16px;
    background-color: white;
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    visibility: visible;
  }

  .tree-legend {
    margin: 35px 16px 10px;
    width: 100%;
    max-width: 160px;
    max-height: calc(100vh - 300px);
    overflow: scroll;
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    padding: 5px;
    visibility: visible;
  }

  .legend-row {
    display: grid;
    grid-template-columns: 25px auto;
  }

  .legend-square {
    display: flex;
    justify-content: center;
    align-content: center;
    transform: translateY(4px);
  }

  .square {
    height: 10px;
    width: 10px;
    background-color: #142142;
  }

  .legend-dot {
    display: flex;
    justify-content: center;
    align-content: center;
    transform: translateY(13px);
  }

  .dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: #EDEDED;
  }

  .horizontal-line {
    border: 0.5px solid gainsboro;
    margin: 10px 0;
  }

  /* Drawer */

  .drawer-wrap {
    position: absolute;
    z-index: 16;
    top: 0;
    right: 0;
    height: 100vh;
    display: flex;
    flex-direction: row;
  }

  .drawer {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/spa/gallery/Piece.vue